export const Module = {
  manufacturer: "/manufacturer",
};

export const EndPoint = {
  /** onboarding */
  login: "/login",
  support: "/support",
  supportDynamicEmail: "/support-dynamic-email",
  dynamicSupportEmail: "/dynamic-support-email",
  manufacturerSupport: "/manufacturer-support",
  verifyEmail: "/verify-mail",
  walletDetails: "/wallet-details",

  /** profile */
  myProfile: "/profile",
  companyprofile: "/company-profile",
  checkUniqueName: "/check-unique-name",
  checkUniqueLicenseNumber: "/check-unique-license",
  licenseApproval: "/license-approve-request",
  license: "/license",
  licenseAddedManually: "/profile/license-numbers/manual",
  manuallyUpdateLicense: "/profile/license-numbers/update",
  deletionRequestLicense: "/profile/license-numbers/deletion-requests",
  importFacilityLicense: "/profile/license-numbers/import",
  importedFacilityLicenseList: "/profile/license-numbers/imported-facilities",
  importedFacilityListing: "/profile/license-numbers/import-facilities-listing",

  /** common */
  getVersion: "/common/panel-version",
  mediaUpload: "/common/media-upload",
  presignedUrl: "/common/preSignedUrl",
  createZendeskTicket: "/zendask/create-ticket",

  /**manufacturer */
  licenseListing: "/license-numbers",

  /** employee management */
  employees: "/employees",
  employeeWallet: "/employees/wallet",
  employeeMFGLicenseList: "/employees/mfg-license",
  disassocateFacility: "/employees/disassociate-facility",

  /** announcement */
  announcements: "/announcements",

  /** rewards */
  rewards: "/rewards",
  ribbions: "/rewards/ribbons",

  /** QR purchasing */
  buySerialNumber: "/buy-serial-number",
  paymentToken: "/qr-code/payment-token",
  serialNumberDetails: "/qr-code/serial-numbers",
  qeCodeListing: "/qr-code/serial-numbers/purchased",
  serialNumberListing: "/qr-code/serial-numbers/for-purchase",
  transactionDetail: "/qr-code/serial-numbers/transaction",
  transactionSKUListing: "/qr-code/serial-numbers/transaction",

  // Cart
  cartListing: "/cart",
  addToCart: "/cart/add",
  cartCheckout: "/cart/checkout",
  removeCartItem: "/cart/remove",
  checkCart: "/cart/has-items-popup",
  cartCheckoutSuccess: "/cart/checkout/success",
  checkActiveCheckout: "/cart/has-active-checkout",
  buyNow: "/cart/checkout/buy-now",

  /**Batches */
  batches: "/batches",
  importBatch: "/batches/add-batches",
  fetchCatergorySubCategory: "/coa/product-types-subtypes",
  fetchLiims: "/coa/add-coa",
  ipfsUpload: "/batches/coa/ipfs-upload",
  refresBatch: "/batches/refresh",
  uploadBatchData: "/batches/upload-batches",
  uploadedBatchList: "/batches/quick-preview",
  associateStrain: "/batches/associate-strain",
  extractFileHeaders: "/batches/extract-file-headers",
  finalizeBatchUpload: "/batches/finalize-batch-upload",
  associatedStrainList: "/batches/strain-list",
  printOnDemand: "/print-on-demand",
  productTokenization: "/batches/product-tokenization",
  productTokenizationDraft: "/batches/product-tokenization/draft",
  addBlockchainTransaction: "/batches/coa/blockchain-txn/add",
  addProductTokenizationTransaction:
    "/batches/product-tokenization/blockchain-txn/add",
  productTokenizationIPFSUpload: "/batches/product-tokenization/ipfs-upload",
  batchesFilter: "/batches/filter-list",
  archiveNonTokenizedBatches: "/archive-status",
  ratings: "/manufacturer/batches/review-rating",
  blockChainDetails: "/batches/product-details",
  downloadLabelCSV: "/batches/serialnumber/download",
  // consumerListing: "/manufacturer/batches/consumer-listing",

  /** Strains */
  strain: "/strain",
  uploadStrainData: "/strain/upload-strains",
  getAsssociatedBatches: "/strain/associated-batches",
  strainExtractFileHeaders: "/strain/extract-file-headers",

  /** API Connections */
  apiConnection: "/api-connections",
  validateAPIKey: "/api-connections-validation",

  /** Accounts */
  accountListing: "/bank-accounts",
  removeAccount: "/bank-accounts/remove",
  getPlaidLink: "/bank-accounts/plaid/add",
  addAccount: "/bank-accounts/micro-deposit/add",
  setPrimaryAccount: "/linked-accounts/set-default",
  verifyAccount: "/bank-accounts/micro-deposit/verify",

  linkedAccountListing: "/linked-accounts",
  generateAeropayToken: "/aggregator-credentials",
  linkAeropayAcccount: "/link-account-from-aggregator",

  /** Subscription */
  subscription: "/subscription",
  subscriptionPlan: "/subscription/plans",
  buySubscription: "/subscription/buy",
  freeTrialBypass: "/subscription/free-trial",
  freeTrialSubscription: "/subscription/free-trial",
  verifyBillingEmail: "/company-profile/billing-email/verify",
  verifyBillingEmailOtp: "/company-profile/billing-email/verify/otp",

  /** Zendesk */
  zendesk: "/zendask",

  /** CMS Link */
  cmsContent: "/cms-content",

  consumers: "/consumers",
  refreshApiConnection: "/api-refresh",

  /** Consumer Management */
  productCollected: "/batches/consumers/collected-products",

  /** Analytics */
  analyticsFilters: "/analytics/filters",
  analyticsEngagementKpis: "/analytics/engagement/kpis",
  analyticsEngagementRates: "/analytics/engagement/rates",
  analyticsEngagementQuickHits: "/analytics/engagement/quick-hits",
  analyticsEngagementTopStrains: "/analytics/engagement/top-strains",
  analyticsEngagementByProductType: "/analytics/engagement/by-product-type",
  analyticsEngagementActivityOverTime:
    "/analytics/engagement/activity-over-time",
  analyticsEngagementDayTimeDistribution:
    "/analytics/engagement/day-time-distribution",
  analyticsConsumersKpis: "/analytics/your-consumers/kpis",
  analyticsConsumersGrowth: "/analytics/your-consumers/growth",
  analyticsConsumersRecency: "/analytics/your-consumers/recency",
  analyticsConsumersBreakdown: "/analytics/your-consumers/reviewer-breakdown",
  analyticsConsumersStrainDiversity:
    "/analytics/your-consumers/strain-diversity",
  analyticsConsumersLeaderboard: "/analytics/your-consumers/leaderboard",
  analyticsConsumersCollectionDistribution:
    "/analytics/your-consumers/collection-distribution",
  analyticsSentimentKpis: "/analytics/consumer-sentiment/kpis",
  analyticsSentimentRatingTrend: "/analytics/consumer-sentiment/rating-trend",
  analyticsSentimentReviewsByStrain:
    "/analytics/consumer-sentiment/reviews-by-strain",
  analyticsSentimentByProductType:
    "/analytics/consumer-sentiment/by-product-type",
  analyticsSentimentRatingsByStrain:
    "/analytics/consumer-sentiment/ratings-by-strain",
  analyticsSentimentAttributeProfile:
    "/analytics/consumer-sentiment/attribute-profile",
  analyticsSentimentReviewDepth: "/analytics/consumer-sentiment/review-depth",
};
